
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16.12","height":"16.12","viewBox":"0 0 800 800","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M166.667 466.667l107.769 80.826c14.29 10.717 34.488 8.267 45.799-5.556L600 200","stroke":"#fff","stroke-width":"66.667","stroke-linecap":"round"}})])
          )
        }
      }
    